<div [id]="chartId" style="width: 100%; height: 400px;"></div>
